// extracted by mini-css-extract-plugin
export default {"infoContainer":"ResultInfo_infoContainer__0Ulcn","title":"ResultInfo_title__6D-KW","text":"ResultInfo_text__wF9AR"};